import { APP_READY } from "../CONSTANTS";

export default function appReady() {
  return {
    type: APP_READY,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/actions/appReady.js